import { Component, type ErrorInfo, type PropsWithChildren, type ReactNode } from 'react';
import { reportErrorToSentry } from '../configuration/setup/sentry';

type ErrorBoundaryProps = {
    fallback: ReactNode;
};

type ErrorBoundaryState = {
    hasError: boolean;
};

export class ErrorBoundary extends Component<PropsWithChildren<ErrorBoundaryProps>, ErrorBoundaryState> {
    constructor(props: PropsWithChildren<{ fallback: ReactNode }>) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(_error: unknown) {
        return { hasError: true };
    }

    componentDidCatch(error: unknown, errorInfo: ErrorInfo) {
        reportErrorToSentry(error, { extra: { componentStack: errorInfo.componentStack } });
        console.error('Unexpected error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback;
        }
        return this.props.children;
    }
}
